const o = {
  OnAccountBalance: "ON_ACCOUNT_BALANCE",
  CreditVoucher: "CREDIT_VOUCHER",
  Pv: "PV",
  Bv: "BV",
  Ampoints: "AMPOINTS",
  StaffEntitlement: "STAFF_ENTITLEMENT"
};
function e(n) {
  return c(n);
}
function c(n, t) {
  return n;
}
function u(n) {
  return n;
}
export {
  o as AccountBalanceAccountType,
  e as AccountBalanceAccountTypeFromJSON,
  c as AccountBalanceAccountTypeFromJSONTyped,
  u as AccountBalanceAccountTypeToJSON
};
//# sourceMappingURL=AccountBalanceAccountType.js.map
